<template>
	<router-view />
</template>

<script>
export default {
	metaInfo: {
		title: 'Hjem',
		titleTemplate: '%s | Interiørverkstedet',
	},
}
</script>
